/**
 * Determines if a view is minimal, which is defined by the view state in which
 * the app is being embedded in an iframe or is being prepared for export.
 * @param {bool} [isEmbedded=false] - Whether the view is embedded or not.
 * @param {bool} [isExporting=false] - Whether the view is being exported or not.
 * @returns {boolean} - Whether the view is minimal or not.
 */
export default function isMinimalView({
  isEmbedded = false,
  isExporting = false,
}) {
  return isEmbedded || isExporting;
}



// WEBPACK FOOTER //
// ./app/services/isMinimalView.js